import { getProjectsList } from '@/api/projects.wp.api'

const state = {
	projectsList: {
		'de-ch': [],
		'en-us': []
	},
	loading: true
}

const actions = {
	loadProjects: ({ commit, state }, payload) => {
		if (!state.projectsList[payload.lang].length) {
			getProjectsList(payload).then(response => {
				commit('PROJECTS_LIST_LOAD')
				commit('PROJECTS_LIST_SAVE', response.data)
			})
		}
	}
}

const mutations = {
	PROJECTS_LIST_LOAD: (state) => {
		state.loading = true
	},
	PROJECTS_LIST_SAVE: (state, projects) => {
		state.loading = false
		state.projectsList[projects[0].lang] = projects
	}
}

const getters = {
	getProjectsByIds: (state) => (options) => {
		return state.projectsList[options.lang].filter(p => (options.ids.indexOf(p.id) > -1))
	},
	getFeaturedProjects: (state) => (options) => {
		return state.projectsList[options.lang].filter(p => p.featured_on_home)
	}
}

export default {
	state,
	actions,
	mutations,
	getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/projects.store.js